export const environment = {
    production: false,
    apiUrl: 'https://api-vce-stg.ogenkisoftlab.com', 
    recaptchaSiteKey: '6LfKwg0qAAAAAO89xFg-qiDyiRGYYDuAXI56LJ2C',
    apiKey: 'gm8UdNkY4n2fSglp0wchaasgiYHNjHfv9FLC56cx',
    noAccountId: 6,
    imageAnswerFilePath: "https://vce-exam-stg.s3.ap-southeast-1.amazonaws.com"
  };
  